/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";

// Images
import team2 from "assets/images/team-2.jpg";

// Material-UI components
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import apiClient from "../../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Divider from "@mui/material/Divider";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

const FetchCategory = ({ onRefresh, editData }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [input, setInput] = useState("");
  const [statusInput, setStatusInput] = useState("Active");
  const [inputFilter, setInputFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // Fetch data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/getCategories");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching getCategories data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [onRefresh]);

  // Handlers
  const handleActivate = async (id, status) => {
    try {
      await apiClient.put(`/admin/category/${id}`, { status: status });
      fetchData(); // Refresh data after status update
    } catch (error) {
      console.error("Error activating location:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/admin/category/${id}`);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting location:", error);
    }
  };

  const handleEdit = (id) => {
    // Handle edit functionality
    console.log("Edit category with ID:", id);
    editData(id);
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleStatusInputChange = (e) => {
    setStatusInput(e.target.value);
  };

  const handleFilterSubmit = () => {
    setInputFilter(input);
    setStatusFilter(statusInput);
  };

  // Filter the rows based on search term
  const filteredRows = data.filter((row) => {
    return (
      (inputFilter === "" || row.name.toLowerCase().includes(inputFilter.toLowerCase())) &&
      (statusFilter === "" || row.status.toLowerCase().includes(statusFilter.toLowerCase()))
    );
  });

  const columns = [
    { Header: "Name", accessor: "name", width: "25%", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = filteredRows.map((item) => ({
    state: (
      <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
        {item.state}
      </MDTypography>
    ),
    district: (
      <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
        {item.district}
      </MDTypography>
    ),
    city: (
      <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
        {item.city}
      </MDTypography>
    ),
    name: (
      <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
        {item.name}
      </MDTypography>
    ),
    status: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={item.status}
          color={item.status === "Active" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    action: (
      <MDBox display="flex" justifyContent="space-around">
        <IconButton onClick={() => handleEdit(item)} color="secondary">
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={() => handleActivate(item._id, item.status)}
          color={item.status === "Active" ? "warning" : "success"}
        >
          <CheckCircleIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(item._id)} color="error">
          <DeleteIcon />
        </IconButton>
      </MDBox>
    ),
  }));

  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div>No data found.</div>;

  const handleClearFilters = () => {
    setInputFilter("");
    setStatusFilter("");
    setInput("");
    setStatusInput("Active");
  };

  return (
    <div>
      <MDBox
        display="flex"
        gap="1rem"
        mb="1rem"
        justifyContent="left"
        alignItems="left"
        ml="2%"
        width="90%"
      >
        <MDInput
          fullWidth
          label="Name"
          variant="outlined"
          value={input}
          onChange={handleInputChange}
        />
        <Select
          fullWidth
          variant="outlined"
          value={statusInput}
          onChange={handleStatusInputChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>Status</em>
          </MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{ color: "#fff" }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClearFilters}
          sx={{ color: "#fff" }}
        >
          Clear
        </Button>
      </MDBox>
      <Divider />
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />
    </div>
  );
};
FetchCategory.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  editData: PropTypes.func.isRequired,
};

export default FetchCategory;
